module.exports = "/assets/data/3749910b35d408216c2b704b85fe735d-LS17.data.json";